<template lang="pug">
#other-user-safety-confirm-answer(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span 施設関係者の安否確認情報（入力依頼内容、回答結果）
    .box-body
      OtherUserSafetyConfirmAnswerTable(
        v-model="items"
        :fields="fields"
        :totalRows.sync="rows"
        :currentPage="currentPage"
        :perPage="perPage"
        :isLoading="isLoading"
        :filter="filter")
      .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
        // 詳細検索
        .flex-fill.mr-2
          button.btn.advanced-filters-btn(@click="showAdvancesFilesr =! showAdvancesFilesr") 
            span(v-show="!showAdvancesFilesr") 詳細検索を表示
            span(v-show="showAdvancesFilesr") 詳細検索を非表示
        // ページあたりの行数
        span.table-option-text 1ページの行数:
        .per-page
          b-form-select(
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="md"
            @change="selectPerPage"
          )
        // ページネーション
        b-pagination.m-0(
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          :disabled="isLoading"
          @change="selectPage"
          hide-goto-end-buttons
        )
      .advanced-filters.mt-2.p-2(v-if="showAdvancesFilesr")
        .d-flex.flex-row.flex-wrap
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold 最新の回答:
            b-form-checkbox(v-model="filter.isLatest") 最新のみ
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm1")
            span.table-option-text.font-weight-bold 本人の状況:
            b-form-checkbox(v-model="filter.confirm1.input0") 無事
            b-form-checkbox(v-model="filter.confirm1.input1") 軽傷
            b-form-checkbox(v-model="filter.confirm1.input2") 重傷
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm2")
            span.table-option-text.font-weight-bold 同居家族の状況:
            b-form-checkbox(v-model="filter.confirm2.input0") 同居家族無し
            b-form-checkbox(v-model="filter.confirm2.input1") 全員無事
            b-form-checkbox(v-model="filter.confirm2.input2") 負傷者有り
            b-form-checkbox(v-model="filter.confirm2.input3") 不明
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm3")
            span.table-option-text.font-weight-bold 住居の状況:
            b-form-checkbox(v-model="filter.confirm3.input0") 無事
            b-form-checkbox(v-model="filter.confirm3.input1") 一部倒壊
            b-form-checkbox(v-model="filter.confirm3.input2") 倒壊
            b-form-checkbox(v-model="filter.confirm3.input3") 不明
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm4")
            span.table-option-text.font-weight-bold 現在の居場所:
            b-form-checkbox(v-model="filter.confirm4.input0") 自宅
            b-form-checkbox(v-model="filter.confirm4.input1") 施設内・会社内
            b-form-checkbox(v-model="filter.confirm4.input2") 移動中
            b-form-checkbox(v-model="filter.confirm4.input3") その他
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm5")
            span.table-option-text.font-weight-bold 出社可否:
            b-form-checkbox(v-model="filter.confirm5.input0") 既に出社
            b-form-checkbox(v-model="filter.confirm5.input1") 出社可能
            b-form-checkbox(v-model="filter.confirm5.input2") 不可能
            b-form-checkbox(v-model="filter.confirm5.input3") その他
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm6")
            span.table-option-text.font-weight-bold 出社見込み時間:
            b-form-checkbox(v-model="filter.confirm6.input0") 既に出社
            b-form-checkbox(v-model="filter.confirm6.input1") 30分以内
            b-form-checkbox(v-model="filter.confirm6.input2") 1時間以内
            b-form-checkbox(v-model="filter.confirm6.input3") 2時間以内
            b-form-checkbox(v-model="filter.confirm6.input4") 3時間以内
            b-form-checkbox(v-model="filter.confirm6.input5") 6時間以内
            b-form-checkbox(v-model="filter.confirm6.input6") 不明、出社不可
          .advanced-filter.mr-2.align-self-start(v-if="showFilter.confirm7")
            span.table-option-text.font-weight-bold 連絡事項:
            b-form-checkbox(v-model="filter.confirm7.isInput") 入力有りのみ

    .box-footer.with-border.register-footer
      .buttons
        button.btn(@click="exportCsv" type="button") 回答結果のファイルダウンロード
        button.btn.cancel-btn(@click="gotoSafetyConfirmDetail" type="button") 戻る

  PageLoading(:isBusy="isLoading" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";
import Setting from "../../../../public/setting.json";

import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserSafetyConfirmMastersService, {
  OtherUserSafetyConfirmMasterInputType,
  OtherUserSafetyConfirmMasterRadioInputOption,
  OtherUserSafetyConfirmMastersGetModel
} from "@/commons/services/OtherUserSafetyConfirmMasters";
import SendSafetyConfirmMessagesService, { SendOtherUserSafetyConfirmLineMessagesGetModel } from "@/commons/services/SendSafetyConfirmMessages";
import SafetyConfirmsService, { SafetyConfirmsGetModel } from "@/commons/services/SafetyConfirms";
import SafetyConfirmReplyMessagesService, { SafetyConfirmReplyMessagesGetModel } from "@/commons/services/SafetyConfirmReplyMessages";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupSendMessageReadMembersService from "@/commons/services/OtherUserGroupSendMessageReadMembers";

import PageLoading from "@/pc/basics/PageLoading.vue";
import OtherUserSafetyConfirmAnswerTable, {
  OtherUserSafetyConfirmAnswerTableField,
  OtherUserSafetyConfirmAnswerTableItem,
  FilterSetting
} from "@/pc/containers/safetyConfirms/OtherUserSafetyConfirmAnswerTable.vue";

/**
 * ###
 */
@Component({
  components: {
    PageLoading,
    OtherUserSafetyConfirmAnswerTable
  }
})
export default class OtherUserSafetyConfirmAnswer extends Vue {
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 安否確認(施設関係者)で送信する質問内容のマスタサービス */
  @Inject("OtherUserSafetyConfirmMastersService") otherUserSafetyConfirmMastersService!: OtherUserSafetyConfirmMastersService;
  /** 安否確認(施設関係者)メッセージ送信サービス */
  @Inject("SendSafetyConfirmMessagesService") sendSafetyConfirmMessagesService!: SendSafetyConfirmMessagesService;
  /** 安否確認サービス */
  @Inject("SafetyConfirmsService") safetyConfirmsService!: SafetyConfirmsService;
  /** 安否確認回答サービス */
  @Inject("SafetyConfirmReplyMessagesService") safetyConfirmReplyMessagesService!: SafetyConfirmReplyMessagesService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 送信メッセージにひもづくメンバーサービス */
  @Inject("OtherUserGroupSendMessageReadMembersService") otherUserGroupSendMessageReadMembersService!: OtherUserGroupSendMessageReadMembersService;

  /** ページ全体ローディング表示可否 */
  isLoading: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 施設関係者への安否確認質問のMAP */
  mastersMap: Map<number, OtherUserSafetyConfirmMastersGetModel> = new Map<number, OtherUserSafetyConfirmMastersGetModel>();

  /** 安否確認 */
  safetyConfirm: SafetyConfirmsGetModel | null = null;
  /** 安否確認(施設関係者)メッセージ */
  messages: Array<SendOtherUserSafetyConfirmLineMessagesGetModel> = [];
  /** 安否確認(施設関係者)の回答 */
  replyMessages: Array<SafetyConfirmReplyMessagesGetModel> = [];

  /** 列 */
  fields: Array<OtherUserSafetyConfirmAnswerTableField> = [];
  /** 行 */
  items: Array<OtherUserSafetyConfirmAnswerTableItem> = [];
  /** ページングの全体行数 */
  rows: number = 0;
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.safetyConfirm.otherUserSafetyConfirmAnswerTable.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.safetyConfirm.otherUserSafetyConfirmAnswerTable.pageOptions;

  /** 詳細検索条件 */
  showAdvancesFilesr: boolean = false;
  /** フィルタリング条件 */
  filter: FilterSetting = {
    isLatest: false,
    confirm1: {
      input0: false,
      input1: false,
      input2: false
    },
    confirm2: {
      input0: false,
      input1: false,
      input2: false,
      input3: false
    },
    confirm3: {
      input0: false,
      input1: false,
      input2: false,
      input3: false
    },
    confirm4: {
      input0: false,
      input1: false,
      input2: false,
      input3: false
    },
    confirm5: {
      input0: false,
      input1: false,
      input2: false,
      input3: false
    },
    confirm6: {
      input0: false,
      input1: false,
      input2: false,
      input3: false,
      input4: false,
      input5: false,
      input6: false
    },
    confirm7: {
      isInput: false
    }
  };
  /** フィルタ表示可否 */
  showFilter: any = {
    confirm1: false,
    confirm2: false,
    confirm3: false,
    confirm4: false,
    confirm5: false,
    confirm6: false,
    confirm7: false
  };

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `other-user-safety-confirm-answer-list-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   *
   * - 表示対象の質問情報のMAPを作る
   */
  public async createView(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.waiter.afterJudgementWaiterListTable.perPage);

    const masters: Array<OtherUserSafetyConfirmMastersGetModel> = await this.getOtherUserSafetyConfirmMasters();
    const mastersMap: Map<number, OtherUserSafetyConfirmMastersGetModel> = this.createMasterMap(masters);
    this.mastersMap = mastersMap;

    const safetyConfirmsId: number = Number(this.$route.params.id);
    const safetyConfirm: SafetyConfirmsGetModel = await this.getSafetyConfirm(safetyConfirmsId);
    this.safetyConfirm = safetyConfirm;

    let messages: Array<SendOtherUserSafetyConfirmLineMessagesGetModel> = [];
    for (const sortKey of safetyConfirm.otherUserMessagesSortKey as string[]) {
      const message: SendOtherUserSafetyConfirmLineMessagesGetModel = await this.getMessage(sortKey);
      messages = messages.concat(message);
    }
    this.messages = messages;

    const fields: Array<OtherUserSafetyConfirmAnswerTableField> = this.createFields(messages, mastersMap);
    this.fields = fields;

    this.setShowConfirm(messages);

    let replyMessages: Array<SafetyConfirmReplyMessagesGetModel> = [];
    for (const sortKey of safetyConfirm.otherUserMessagesSortKey as string[]) {
      replyMessages = replyMessages.concat(await this.getSafetyConfirmReplyMessages(sortKey));
    }
    this.replyMessages = replyMessages;

    const items: Array<OtherUserSafetyConfirmAnswerTableItem> = this.createItems(replyMessages, mastersMap);
    this.items = items;

    this.isLoading = false;

    return;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["other-user-safety-confirm-answer-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /**
   * ### 安否確認(施設関係者)で送信する質問内容のマスタを取得する
   */
  public async getOtherUserSafetyConfirmMasters(): Promise<Array<OtherUserSafetyConfirmMastersGetModel>> {
    const response: Array<OtherUserSafetyConfirmMastersGetModel> = await this.otherUserSafetyConfirmMastersService.get(userStore);
    return response;
  }

  /**
   * ### 質問内容マスタのMAPを作成する
   */
  public createMasterMap(masters: Array<OtherUserSafetyConfirmMastersGetModel>): Map<number, OtherUserSafetyConfirmMastersGetModel> {
    let map: Map<number, OtherUserSafetyConfirmMastersGetModel> = new Map<number, OtherUserSafetyConfirmMastersGetModel>();
    for (const master of masters) {
      map.set(master.id, master);
    }
    return map;
  }

  /**
   * ### 安否確認を取得する
   */
  public async getSafetyConfirm(safetyConfirmsId: number): Promise<SafetyConfirmsGetModel> {
    const response: SafetyConfirmsGetModel = await this.safetyConfirmsService.get(userStore, safetyConfirmsId);
    return response;
  }

  /**
   * ### 安否確認(施設関係者)メッセージを取得する
   */
  public async getMessage(parentOtherUserMessagesSortKey: string): Promise<SendOtherUserSafetyConfirmLineMessagesGetModel> {
    const response: SendOtherUserSafetyConfirmLineMessagesGetModel = await this.sendSafetyConfirmMessagesService.getOtherUserMessage(userStore, parentOtherUserMessagesSortKey);
    return response;
  }

  /**
   * ### 安否確認(施設関係者)の回答を取得する
   */
  public async getSafetyConfirmReplyMessages(messagesSortKey: string): Promise<Array<SafetyConfirmReplyMessagesGetModel>> {
    const response: Array<SafetyConfirmReplyMessagesGetModel> = await this.safetyConfirmReplyMessagesService.gets(userStore, messagesSortKey);
    return response;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(
    messages: Array<SendOtherUserSafetyConfirmLineMessagesGetModel>,
    mastersMap: Map<number, OtherUserSafetyConfirmMastersGetModel>
  ): Array<OtherUserSafetyConfirmAnswerTableField> {
    let fields: Array<OtherUserSafetyConfirmAnswerTableField> = [];

    fields.push({ key: "groupName", label: "グループ名", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "groupMemberName", label: "氏名", sortable: false, sortDirection: "desc", class: "group-member-name" });
    fields.push({ key: "groupMemberOrganization", label: "所属", sortable: false, sortDirection: "desc", class: "group-member-organization" });
    fields.push({ key: "groupMemberTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "group-member-tel" });
    fields.push({ key: "created", label: "登録日時", sortable: false, sortDirection: "desc", class: "created" });
    fields.push({ key: "isLatest", label: "最新の登録", sortable: false, sortDirection: "desc", class: "is-latest" });

    for (const confirm of messages[0].functionContents.confirmationContents) {
      const displayConfirm: OtherUserSafetyConfirmMastersGetModel | undefined = mastersMap.get(confirm);

      if (displayConfirm != undefined) {
        fields.push({ key: `${displayConfirm.id}`, label: displayConfirm.label, sortable: false, sortDirection: "desc", class: `confirm-${displayConfirm.id}` });
      }
    }

    return fields;
  }

  /**
   * ### 詳細検索のフィルタ項目の表示可否を設定する
   */
  public setShowConfirm(messages: Array<SendOtherUserSafetyConfirmLineMessagesGetModel>): void {
    for (const confirm of messages[0].functionContents.confirmationContents) {
      this.showFilter[`confirm${confirm}`] = true;
    }
    return;
  }

  /**
   * ### 行を作成する
   */
  public createItems(
    replyMessages: Array<SafetyConfirmReplyMessagesGetModel>,
    masterMap: Map<number, OtherUserSafetyConfirmMastersGetModel>
  ): Array<OtherUserSafetyConfirmAnswerTableItem> {
    let items: Array<OtherUserSafetyConfirmAnswerTableItem> = [];

    for (const replyMessage of replyMessages) {
      let item: OtherUserSafetyConfirmAnswerTableItem | any = {
        groupName: replyMessage.groupName,
        groupMemberName: replyMessage.groupMemberName,
        groupMemberOrganization: replyMessage.groupMemberOrganization,
        groupMemberTel: replyMessage.groupMemberTel,
        created: replyMessage.created,
        isLatest: replyMessage.latest
      };

      for (const answer of replyMessage.answers) {
        const master: OtherUserSafetyConfirmMastersGetModel = masterMap.get(answer.id) as OtherUserSafetyConfirmMastersGetModel;
        switch (master.inputType) {
          case OtherUserSafetyConfirmMasterInputType.RADIO: {
            const radioInputOption: OtherUserSafetyConfirmMasterRadioInputOption = master.inputOptions as OtherUserSafetyConfirmMasterRadioInputOption;
            for (const choice of radioInputOption.choices) {
              if (answer.answer == choice.value) {
                item[`${answer.id}-value`] = choice.value;
                item[`${answer.id}`] = choice.label;
              }
            }
            break;
          }
          case OtherUserSafetyConfirmMasterInputType.MULTIPLE_TEXT: {
            if (answer.answer != null) {
              item[`${answer.id}`] = answer.answer ? answer.answer : "";
            }
            break;
          }
          default: {
            break;
          }
        }
      }

      items.push(item);
    }

    return items;
  }

  /**
   * ### CSVエクスポート
   */
  public exportCsv(): void {
    const csv: string = this.createCsv(this.replyMessages, this.fields, this.mastersMap);
    const fileName: string = this.createCsvFileName(this.safetyConfirm as SafetyConfirmsGetModel);
    this.downloadCsv(csv, fileName);
    return;
  }

  /**
   * ### 安否確認の返信のCSVを作成する
   *
   * - 1行目の先頭はexcel等での文字化け対策でBOMを付与する
   * - 1行目は項目名を作る
   * - 2行目以降は行情報にあたる情報を作成して出力する
   *   - 入力種別がラジオボタンの場合はラジオボタンのラベル名を使用する
   *   - 入力種別がテキスト入力(複数行)の場合は入力内容をそのまま使用する
   */
  public createCsv(
    replyMessages: Array<SafetyConfirmReplyMessagesGetModel>,
    fields: Array<OtherUserSafetyConfirmAnswerTableField>,
    masterMap: Map<number, OtherUserSafetyConfirmMastersGetModel>
  ): string {
    let csv: string = `\ufeff`;

    let rowNames: string[] = [];
    for (const field of fields) {
      rowNames.push(field.label);
    }
    csv = csv + `${rowNames.join(",")}\n`;

    for (const replyMessage of replyMessages) {
      let line: string = "";
      for (const answer of replyMessage.answers) {
        let answerText: string = "";
        const master: OtherUserSafetyConfirmMastersGetModel = masterMap.get(answer.id) as OtherUserSafetyConfirmMastersGetModel;
        switch (master.inputType) {
          case OtherUserSafetyConfirmMasterInputType.RADIO: {
            const radioInputOption: OtherUserSafetyConfirmMasterRadioInputOption = master.inputOptions as OtherUserSafetyConfirmMasterRadioInputOption;
            for (const choice of radioInputOption.choices) {
              if (answer.answer == choice.value) {
                answerText = choice.label;
              }
            }
            break;
          }
          case OtherUserSafetyConfirmMasterInputType.MULTIPLE_TEXT: {
            if (answer.answer != null) {
              answerText = answer.answer;
            }
            break;
          }
          default: {
            break;
          }
        }
        line += answerText + ",";
      }
      line = line.slice(0, -1); // 末尾の「,」を削除
      const latestText: string = replyMessage.latest == true ? "はい" : "いいえ";
      const date: string = this.$dateUtil.convertNumberToString(replyMessage.created, "yyyy/mm/dd hh:MM:ss");
      csv += `${replyMessage.groupName},${replyMessage.groupMemberName},${replyMessage.groupMemberOrganization},="${replyMessage.groupMemberTel}",${date},${latestText},${line}\n`;
    }
    return csv;
  }

  /**
   * ### CSVファイル名を作成する
   */
  public createCsvFileName(safetyConfirm: SafetyConfirmsGetModel): string {
    const date: string = this.$dateUtil.convertNumberToString(safetyConfirm.created, "yyyymmdd");
    const fileName: string = `HitomeQコネクト-安否確認-施設関係者-${safetyConfirm.name}-${date}.csv`;
    return fileName;
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    return;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;

    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    return;
  }

  /**
   * ### 安否確認詳細画面に遷移する
   */
  public gotoSafetyConfirmDetail(): void {
    const safetyConfirmsId: number = Number(this.$route.params.id);
    this.$router.push({ name: PcUrl.OtherUserSafetyConfirmDetail, params: { id: `${safetyConfirmsId}` } });
    return;
  }
}
</script>

<style lang="scss" scoped>
#other-user-safety-confirm-answer {
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  .cancel-btn {
    width: 130px;
  }
}
</style>
